import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  flex: 1;
  gap: 2rem;
`;
